<template>
  <div>
    <Divider orientation="left" style="margin-bottom: 0px;">基础信息</Divider>
    <Row class="p-b-5 p-t-10">
      <i-col span="8"
        ><span class="title text-title-65">账单名称</span>{{ detailBean.billName }}</i-col
      >
      <i-col span="8"
        ><span class="title text-title-65">对应合同 </span>{{ detailBean.contractName }}</i-col
      >
      <i-col span="8"
        ><span class="title text-title-65">付款单位 </span>{{ detailBean.advertiserName }}</i-col
      >
    </Row>
    <Row>
      <i-col span="8">
        <span class="title text-title-65">状态 </span>
        <Tag v-if="detailBean.billStatus === 0" color="default">{{ detailBean.billStatusName }}</Tag>
        <Tag v-else color="green" border>{{ detailBean.billStatusName }}</Tag>
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">创建人 </span>{{ detailBean.createUserName }}
      </i-col>
      <i-col span="8"
        ><span class="title text-title-65">创建时间 </span>{{ detailBean.createTime }}</i-col
      >
    </Row>
    <Row>
      <i-col span="24">
        <span class="title text-title-65">备注</span>{{ detailBean.mark }}
      </i-col>
    </Row>

    <Divider orientation="left" style="margin-bottom: 0px;">费用清单</Divider>
    <Row class="m-b-5">
      <i-col flex="100px">
        账单总额
      </i-col>
      <i-col flex="100px" class="text-right">
        {{ formatMoney(detailBean.totalAmount) }}
      </i-col>
    </Row>
    <Row class="m-b-5">
      <i-col flex="100px">
        调差项
      </i-col>
      <i-col flex="100px" class="text-right warning text-bold">
        {{ formatMoney(detailBean.adjustAmount) }}
      </i-col>
      <i-col flex="auto" class="p-l-5" v-if="detailBean.billStatus!==5">
        <a @click="handleChangeMoney"><Icon type="md-create" />设置</a>
      </i-col>
    </Row>
    <Row><i-col flex="200px"><hr/></i-col></Row>
    <Row class="m-b-5">
      <i-col flex="100px">
        应付金额
      </i-col>
      <i-col flex="100px" class="text-right">
        {{ formatMoney(detailBean.actualAmount) }}
      </i-col>
    </Row>

    <Divider orientation="left" style="margin-bottom: 0px;">收款明细</Divider>
    <Row>
      <i-col span="12">
        <Row class="p-b-5">
          <i-col span="24">
            <span class="title text-title-85">预计付款日期 </span>
            {{ detailBean.expectPayDate }}
            <Button v-if="detailBean.billStatus!==5" type="success" size="small" icon="md-bulb" class="m-l-10" @click="handleFinishDebt">标记收款</Button>
            <Button v-if="detailBean.billStatus!==5" type="success" size="small" class="m-l-10" icon="md-download" @click="handleExportNotify">导出缴费通知单</Button>
          </i-col>
        </Row>
        <template>
          <Row class="p-b-5">
            <i-col span="24">
              <span class="title text-title-85">实际收款日期 </span>
              {{ detailBean.receiveDate }}
            </i-col>
          </Row>
          <Row>
            <i-col span="24">
              <span class="title text-title-85">收款备注 </span>
              {{ detailBean.receiveMark }}
            </i-col>
          </Row>
        </template>
      </i-col>
      <i-col span="12">
        <fileMeterBill ref="fileMeterBillComponent"/>
      </i-col>
    </Row>

    <Divider orientation="left" style="margin-bottom: 0px;">费用明细</Divider>
    <Row v-if="detailBean.billStatus!==5">
      <i-col span="24" class="m-b-5">
        <a v-if="selectedIds.length>0" @click="handleBatchDelete"><Icon type="ios-trash-outline" />批量移除电费单</a>
        <span v-else class="remark" style="cursor: no-drop;"><Icon type="ios-trash-outline" />批量移除电费单</span>
        <Divider type="vertical" />
        <a @click="handleChoiceBill"><Icon type="md-add" />添加电费单</a>
      </i-col>
    </Row>
    <Table stripe :columns="tableColumns" size="small" :data="tableData"
      @on-selection-change="selectionChange"
      :loading="tableLoading"
    ></Table>
    <div class="paging_style">
      <Page size="small" :total="totalRow" :page-size="query.size" show-total show-elevator
        :current="query.current" @on-change="handleChangePage"></Page>
    </div>

    <finishMeterBill  ref="finishMeterBillModal" @on-success="initPageData"></finishMeterBill>
    <choiceMeterBill  ref="choiceMeterBillModal" @on-success="initPageData" ></choiceMeterBill>

    <Modal v-model="modalChangeMoney" width="400">
      <p slot="header" class="text-center">设置调差项</p>
      <Row class="p-b-10">
        <i-col span="4"><span class="title text-title-65">总额</span></i-col>
        <i-col span="20">
          {{ formatMoney(detailBean.totalAmount) }}
        </i-col>
      </Row>

      <Row class="p-b-10">
        <i-col span="4"><span class="title text-title-65">调差额</span></i-col>
        <i-col span="20">
          <InputNumber :max="100000000" style="width: 140px;" v-model="changeBean.adjustAmount"></InputNumber>
        </i-col>
      </Row>

      <!-- <Row class="p-b-10">
        <i-col span="4"><span class="title text-title-65">调差备注</span></i-col>
        <i-col span="20">
          <Input v-model="changeBean.adjustRemark" maxlength="500" :rows="4" show-word-limit type="textarea" placeholder="请输入调整备注信息..." style="width: 300px" />
        </i-col>
      </Row> -->

      <div slot="footer">
        <Button type="text" class="m-r-5" @click="modalChangeMoney = false">取消</Button>
        <Button type="primary" @click="handleSubmitChange">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import finishMeterBill from './FinishMeterBill.vue'
import choiceMeterBill from './ChoiceMeterBill.vue'
import fileMeterBill from './MeterBillFile.vue'
// utils
import { toMoney } from '@/utils/wnumb_own'
import { downloadFileRequest } from '@/utils/download'
// apis
import { getElectricBillDetail, addAdjustAmount, removeFeeItemFromBill } from '@/api/invest/electricMeterBill'
import { pageElectricMeterRecord } from '@/api/invest/electricMeterRecord'

export default {
  components: {
    choiceMeterBill, finishMeterBill, fileMeterBill
  },
  props: {},
  data () {
    return {
      detailBean: {},

      query: {
        current: 1,
        size: 10,
        billId: null
      },

      modalChangeMoney: false,
      changeBean: {
        adjustAmount: 0,
        adjustRemark: null,
        billId: null
      },

      selectedIds: [],
      tableLoading: false,
      totalRow: 0,
      tableData: [],
      tableColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '资源编号', key: 'deviceCode' },
        { title: '电表编号', key: 'meterCode' },
        { title: '最近抄表时间', key: 'readDate' },
        { title: '上期读数/底表读数', key: 'lastValue' },
        { title: '本期读表数', key: 'currentValue' },
        { title: '本期用电量(kwh)', key: 'electricityConsume' },
        { title: '线损', key: 'lineLost' },
        {
          title: '电费单价',
          key: 'unitPrice',
          render: (h, params) => {
            return h('strong', {},
              toMoney(params.row.unitPrice))
          }
        },
        {
          title: '本期电费合价(元)',
          key: 'chargeAmount',
          render: (h, params) => {
            return h('strong', {
              attrs: {
                style: 'color:#44bd32'
              }
            },
            toMoney(params.row.chargeAmount))
          }
        },
        { title: '计价月份', key: 'chargeMonthStr' }
      ]
    }
  },
  mounted () {},
  created () {
    this.initPageData()
  },
  methods: {
    initPageData () {
      if (this.detailId) {
        this.initDetail()
        this.query.billId = this.detailId
        this.loadElectricMeterRecord()
        this.$nextTick(() => {
          this.$refs.fileMeterBillComponent.initPageData(this.detailId)
        })
      }
    },
    formatMoney (number) {
      return toMoney(number)
    },
    initDetail () {
      getElectricBillDetail({ billId: this.detailId }).then(res => {
        this.detailBean = res
      })
    },
    loadElectricMeterRecord () {
      this.tableLoading = true
      pageElectricMeterRecord(this.query).then(res => {
        const pageData = res.records
        // 需要自动勾选被选中的项
        pageData.forEach(item => {
          item._checked = this.selectedIds.includes(item.meterRecordId)
        })

        this.tableData = pageData
        this.totalRow = res.total
        this.tableLoading = false
      })
    },
    handleChangePage (currentPage) {
      this.query.current = currentPage
      this.loadElectricMeterRecord()
    },
    selectionChange (selections) {
      const curSelection = selections.map(x => x.meterRecordId)
      this.tableData.forEach(item => {
        // 当前被勾选
        if (curSelection.includes(item.meterRecordId)) {
          if (!this.selectedIds.includes(item.meterRecordId)) {
            this.selectedIds.push(item.meterRecordId)
          }
        } else {
          // 当前未被勾选， 且存在勾选清单，那么移除
          if (this.selectedIds.includes(item.meterRecordId)) {
            const index = this.selectedIds.findIndex(x => x === item.meterRecordId)
            this.selectedIds.splice(index, 1)
          }
        }
      })
    },
    handleChangeMoney () {
      this.modalChangeMoney = true
      this.changeBean.billId = this.detailId
      this.changeBean.adjustAmount = this.detailBean.adjustAmount
      // this.changeBean.adjustRemark = this.detailBean.adjustRemark
    },
    handleSubmitChange () {
      addAdjustAmount(this.changeBean).then(res => {
        this.initDetail()
        this.$Notice.success({ desc: '设置调差项成功！' })
        this.modalChangeMoney = false
      })
    },
    handleChoiceBill () {
      this.$refs.choiceMeterBillModal.showModal(this.detailBean.contractId, this.detailId)
    },
    handleFinishDebt () {
      this.$refs.finishMeterBillModal.showModal(this.detailId)
    },
    handleExportNotify () {
      const fileName = this.detailBean.billName + '电费缴费通知单.xlsx'
      const query = {
        billId: this.detailId
      }

      downloadFileRequest(process.env.VUE_APP_API_URL_V2 + '/ooh-invest/electricBillExport/exportBill', query, fileName)
    },
    handleBatchDelete () {
      this.$Modal.confirm({
        title: '确定删除？',
        content: '<p>确定要批量删除电费单吗？</p>',
        loading: true,
        onOk: () => {
          const deleteBean = {
            billId: this.detailId,
            meterRecordIdStr: JSON.stringify(this.selectedIds)
          }

          removeFeeItemFromBill(deleteBean).then(res => {
            this.$Notice.success({ desc: '操作成功' })
            this.initPageData()
          }).finally(() => {
            this.$Modal.remove()
          })
        }
      })
    }
  },
  watch: {
    detailId () {
      this.initDetail()
    },
    beginUpdate () {
      this.initDetail()
    }
  },
  computed: {
    detailId () {
      return this.$store.state.investmentElecCollection.detailId
    },
    beginUpdate () {
      return this.$store.state.investmentElecCollection.beginUpdate
    }
  }
}
</script>
